import React, { useState } from 'react'
import styles from '../sidebar.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTasks, faBuilding, faChevronDown, faChevronUp, faCircleChevronLeft, faDatabase, faFileAlt, faFileLines, faGripVertical, faHeadphones, faListAlt, faMicrophone, faMicrophoneAlt, faMicrophoneLines, faPlus, faRectangleList, faRightFromBracket, faThLarge, faUsers } from '@fortawesome/free-solid-svg-icons';
import { Collapse } from 'react-bootstrap';

const Index = ({ isSidebarCollapsed, setIsSidebarCollapsed }) => {
    const [openJobs, setOpenJobs] = useState(false);
    const [openInternships, setOpenInternships] = useState(false);
    const [openAdmin, setOpenAdmin] = useState(false);
    const [isRightbarExpanded, setRightbarExpanded] = useState(false);
    // const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const toggleSidebar = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };
    const toggleRightbar = () => {
        setRightbarExpanded((prev) => !prev);
    };
    const [activeIndex, setActiveIndex] = useState(null);

    const menuItems = [
        { name: "Jobs", icon: faListAlt },
        { name: "Documents", icon: faFileAlt },
        { name: "Database", icon: faDatabase },
        { name: "Users", icon: faUsers },
        { name: "Apps", icon: faThLarge },
    ];
    return (
        <React.Fragment>
            <div className={`${styles['mobile-view']} container`}>
                <div className='row'>
                    <div className='col-md-12'>
                        <nav className={`${styles['menu-container']}`}>
                            <ul className={`${styles['menu-list']}`}>
                                {menuItems.map((item, index) => (
                                    <li
                                        key={index}
                                        className={`${styles['menu-item']} ${activeIndex === index ? "active" : ""}`}
                                        onClick={() => setActiveIndex(index)}
                                    >
                                        <FontAwesomeIcon icon={item.icon} className={`${styles["menu-icon"]} ${activeIndex === index ? styles["active-icon"] : ""}`} />
                                        {activeIndex === index && <span className={`${styles['menu-text']}`}>{item.name}</span>}
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </div>

                </div>
            </div>
        </React.Fragment>
    )
}

export default Index